import "./App.css";

// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { routes } from "./routes";
import { LayoutProvider, useLayout } from "./lib/contexts/layout.context";
import { BrowserRouter, useRoutes } from "react-router-dom";
import { Toaster } from "sonner";
import LoadingSpinner from "./components/loadingSpinner.component";
import { Suspense } from "react";
import { CookiesProvider } from "react-cookie";
import { AuthProvider, useAuth } from "./lib/contexts/auth.context";
import { Navbar } from "./components/ui/navbar";
import * as Sentry from "@sentry/react";

Sentry.init({
	dsn: "https://1f26aca42304dfec7a92d06f77375aba@o4508817033723904.ingest.de.sentry.io/4509999767945296",
	integrations: [
		Sentry.browserTracingIntegration(),
		Sentry.replayIntegration(),
	],
	// Tracing
	tracesSampleRate: 1.0, //  Capture 100% of the transactions
	// Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
	// we are currently only interested in the api and the app (release environment)
	tracePropagationTargets: [
		"localhost",
		/^https:\/\/api.app.korrektur.taxpeer\.de/,
		/^https:\/\/app.korrektur.taxpeer\.de/,
	],
	// Session Replay
	replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
	replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
	enabled: process.env.NODE_ENV === "production",
});

initializeApp(JSON.parse(import.meta.env.VITE_FIREBASE_CONFIG));

function App() {
	return (
		<BrowserRouter>
			<CookiesProvider>
				<AuthProvider>
					<LayoutProvider>
						<Suspense fallback={<LoadingSpinner />}>
							<AppRoutes />
						</Suspense>
					</LayoutProvider>
				</AuthProvider>
			</CookiesProvider>
			<Toaster />
		</BrowserRouter>
	);
}

/**
 * AppRoutes component that uses the useRoutes hook
 *
 * It will display the navbar if the user is authenticated and a info banner if the user is not verified
 */
function AppRoutes() {
	const { isAuthenticated } = useAuth();
	const { showNavbar } = useLayout();

	// If the user is authenticated, conditionally display the navbar based on context
	if (isAuthenticated) {
		return (
			<>
				{showNavbar && <Navbar />}
				{useRoutes(routes)}
			</>
		);
	}

	// If the user is not authenticated, display the routes
	return useRoutes(routes);
}

export default App;
